import { CSAT_RATINGS } from '../../../../../shared/constants/messages';

const generateInputSelectContent = contentAttributes => {
  const { submitted_values: submittedValues = [] } = contentAttributes;
  const [selectedOption] = submittedValues;

  if (selectedOption && selectedOption.title) {
    return `<strong>${selectedOption.title}</strong>`;
  }
  return '';
};

const generateInputEmailContent = contentAttributes => {
  const { submitted_email: submittedEmail = '' } = contentAttributes;
  if (submittedEmail) {
    return `<strong>${submittedEmail}</strong>`;
  }
  return '';
};

const generateFormContent = (contentAttributes, { noResponseText }) => {
  const { items, submitted_values: submittedValues = [] } = contentAttributes;
  if (submittedValues.length) {
    const submittedObject = submittedValues.reduce((acc, keyValuePair) => {
      acc[keyValuePair.name] = keyValuePair.value;
      return acc;
    }, {});
    let formMessageContent = '';
    items.forEach(item => {
      formMessageContent += `<div>${item.label}</div>`;
      const response = submittedObject[item.name] || noResponseText;
      formMessageContent += `<strong>${response}</strong><br/><br/>`;
    });
    return formMessageContent;
  }
  return '';
};

const formatFlowFieldName = name => {
  if (!name) return '';

  const cleaned = name.replace(/^screen_\d+_/i, '').replace(/_\d+$/, '');
  return cleaned
    .replace(/_/g, ' ')
    .replace(/\b\w/g, character => character.toUpperCase());
};

const formatFlowFieldValue = value => {
  if (Array.isArray(value)) {
    return value.join(', ');
  }

  if (typeof value === 'string' && value.startsWith('[')) {
    try {
      const parsed = JSON.parse(value);
      if (Array.isArray(parsed)) {
        return parsed.join(', ');
      }
    } catch (error) {
      // Keep original string when JSON parsing fails.
    }
  }

  if (value && typeof value === 'object') {
    return JSON.stringify(value);
  }

  return value ?? '';
};

const FLOW_RESPONSE_HIDDEN_FIELDS = ['flow_token'];

const visibleFlowSubmittedValues = submittedValues =>
  submittedValues.filter(
    ({ name }) => !FLOW_RESPONSE_HIDDEN_FIELDS.includes(name?.toLowerCase())
  );

export const generateFlowResponseContent = (
  contentAttributes,
  { flowResponseTitle = 'WhatsApp Flow Response', noResponseText = 'No response' } = {}
) => {
  const submittedValues = visibleFlowSubmittedValues(
    contentAttributes.submitted_values || []
  );

  let messageContent = `<div><strong>${flowResponseTitle}</strong></div><br/>`;

  submittedValues.forEach(({ name, value }) => {
    const label = formatFlowFieldName(name);
    const formattedValue = formatFlowFieldValue(value) || noResponseText;
    messageContent += `<div>${label}</div>`;
    messageContent += `<strong>${formattedValue}</strong><br/><br/>`;
  });

  return messageContent;
};

const generateCSATContent = (
  contentAttributes,
  { ratingTitle, feedbackTitle }
) => {
  const {
    submitted_values: { csat_survey_response: surveyResponse = {} } = {},
  } = contentAttributes;
  const { rating, feedback_message } = surveyResponse || {};

  let messageContent = '';
  if (rating) {
    const [ratingObject = {}] = CSAT_RATINGS.filter(
      csatRating => csatRating.value === rating
    );
    messageContent += `<div><strong>${ratingTitle}</strong></div>`;
    messageContent += `<p>${ratingObject.emoji}</p>`;
  }
  if (feedback_message) {
    messageContent += `<div><strong>${feedbackTitle}</strong></div>`;
    messageContent += `<p>${feedback_message}</p>`;
  }
  return messageContent;
};

export const generateBotMessageContent = (
  contentType,
  contentAttributes,
  {
    noResponseText = 'No response',
    flowResponseTitle = 'WhatsApp Flow Response',
    csat: { ratingTitle = 'Rating', feedbackTitle = 'Feedback' } = {},
  } = {}
) => {
  if (contentAttributes?.flow_response) {
    return generateFlowResponseContent(contentAttributes, {
      flowResponseTitle,
      noResponseText,
    });
  }

  const contentTypeMethods = {
    input_select: generateInputSelectContent,
    input_email: generateInputEmailContent,
    form: generateFormContent,
    input_csat: generateCSATContent,
  };

  const contentTypeMethod = contentTypeMethods[contentType];
  if (contentTypeMethod && typeof contentTypeMethod === 'function') {
    return contentTypeMethod(contentAttributes, {
      noResponseText,
      ratingTitle,
      feedbackTitle,
    });
  }
  return '';
};
